import { render, staticRenderFns } from "./invite-button.vue?vue&type=template&id=3bc59a26&scoped=true"
import script from "./invite-button.vue?vue&type=script&lang=js"
export * from "./invite-button.vue?vue&type=script&lang=js"
import style0 from "./invite-button.vue?vue&type=style&index=0&id=3bc59a26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc59a26",
  null
  
)

export default component.exports